import { render, staticRenderFns } from "./gc-header-content-dynamic.vue?vue&type=template&id=c0aa00e6&"
import script from "./gc-header-content-dynamic.vue?vue&type=script&lang=js&"
export * from "./gc-header-content-dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports